export class DeviceRequest {
    constructor(
        public dbName: string,
        public idDispositivo: string,
        public qrCodeConfig: string,
        public nomeTerminal: string,
    ) { }
}

export class DeviceViewModel {
    public dbName: string = '';
    public idDispositivo: string = '';
    public qrCodeConfig: string = ''
    public nomeTerinal: string = '';
}
